import { Typo } from '@geberit/gdds';

// styles
import styles from './order-details-box.module.scss';

// components
import { Translation } from 'components/Translation/Translation';
import { Headline } from 'components/ContentElementsGdds/headline/headline';

// utils
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';
import { useXy } from 'utils/hooks/use-xy';

type OrderDetailsBoxProps = {
  orderId: string | null;
  title: string;
  orderData: {
    orderNumber?: string;
    paymentType?: string;
    paymentMethod?: string;
  };
};

function OrderDetailsBox({
  orderData = {},
  orderId = null,
  title,
}: Readonly<OrderDetailsBoxProps>) {
  const isXy = useXy();

  const listContent = (
    <>
      <li>
        <Translation id="web20_checkout_summary_order_details_payment" /> {orderData.paymentType}
      </li>
      {orderId && (
        <li>
          <Translation id="web20_checkout_summary_order_details_number" /> {orderId}
        </li>
      )}
    </>
  );

  return (
    <div>
      {isXy ? (
        <>
          <Headline
            tag={Formats.h4}
            variant={Formats.subtitle}
            className={`${styles.orderDetailsBoxHeadline} ${styles.bottomMargin}`}
            title={title}
          />
          <Typo tag="ul" className={`${styles.orderDetailsBoxWrapper} ${styles.bottomMargin}`}>
            {listContent}
          </Typo>
        </>
      ) : (
        <>
          <h4 className={styles.bottomMargin}>{title}</h4>
          <ul className={`${styles.orderDetailsBoxWrapper} ${styles.bottomMargin}`}>
            {listContent}
          </ul>
        </>
      )}
    </div>
  );
}

export default OrderDetailsBox;
